import { PsmVideoPlayer, PsmTop2, PsmDiscovery } from '@turnercode/cdp-prism-module-telemetry/web';
import { Psm } from './Psm';

const psm = new Psm();
window.psmVideo = {
  ...window.psmVideo,
  top2: {
    startMonitoring: (player: PsmVideoPlayer) => {
      return new PsmTop2(player, psm);
    },
  },
  discovery: {
    startMonitoring: (player: PsmVideoPlayer) => {
      return new PsmDiscovery(player, psm);
    },
  },
};
// window.psmVideo.top2.startMonitoring(player);

export * from './Psm';
